import { ReactNode } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";

import cn from "classnames";

import { Icon } from "@/components/Icon";

import styles from "./Checkbox.module.scss";

type CheckboxProps = {
  containerClassName?: string;
  children?: ReactNode;
  checked?: boolean;
  type?: "checkbox" | "radio";
  name?: string;
  onChecked?: (_: boolean) => void;
  onClicked?: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary";
};

export const Checkbox = function Checkbox(props: CheckboxProps) {
  const {
    containerClassName,
    children,
    checked,
    type = "checkbox",
    name,
    onChecked,
    onClicked,
    variant = "primary",
    ...inputProps
  } = props;

  const [currentChecked, setCurrentChecked] = useState(checked);

  const containerClasses = cn(styles.container, containerClassName);

  const checkboxClasses = cn(styles.checkbox, styles[variant], {
    [styles.checked]: currentChecked,
    [styles.hasLabel]: !!children,
  });

  const handleChange = useCallback(() => {
    setCurrentChecked((prev) => !prev);
  }, [setCurrentChecked]);

  const handleClick = useCallback(() => {
    onClicked?.();
  }, [onClicked]);

  useEffect(() => {
    onChecked?.(currentChecked ?? false);
  }, [currentChecked, onChecked]);

  useEffect(() => {
    setCurrentChecked(checked);
  }, [checked, setCurrentChecked]);

  return (
    <label className={containerClasses}>
      <input
        type={type}
        hidden
        name={name}
        onChange={handleChange}
        onClick={handleClick}
        checked={currentChecked}
        {...inputProps}
      />
      <div className={checkboxClasses}>
        <Icon icon="checkbox-check" />
      </div>
      <span>{children}</span>
    </label>
  );
};
